import { render, staticRenderFns } from "./ConfiguredCustomFields.vue?vue&type=template&id=44f7970e"
import script from "./ConfiguredCustomFields.vue?vue&type=script&lang=js"
export * from "./ConfiguredCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports